import type { TFunction } from 'i18next';
import { UsageMetricKey } from '../../../../Constants/VOSS/usageMetricKey';
import { UsageStatus } from '../../../../Constants/VOSS/usageTypes';
import { badgeVariantByStatus } from './usageStatusStyles';

interface StatusBadgeProps {
    status: UsageStatus;
    percent: number;
    metricKey: UsageMetricKey;
    t: TFunction;
}

const StatusBadge = ({ status, percent, metricKey, t }: StatusBadgeProps) => {
    let text: string | null = null;
    if (metricKey === UsageMetricKey.CustomerInvoices) text = t('vossusage.status.perUnit');
    else if (status === UsageStatus.Warning) text = t('vossusage.status.almostFull', { percent });
    else if (status === UsageStatus.Over) text = t('vossusage.status.overLimit');

    const visible = text !== null;
    const variant = badgeVariantByStatus[status];
    const variantClass = variant === '' ? '' : ` ${variant}`;
    const visibilityClass = visible ? '' : ' invisible';
    return (
        <span
            className={`badge text-nowrap m-0${variantClass}${visibilityClass}`}
            aria-hidden={!visible}
        >
            {text ?? ' '}
        </span>
    );
};

export default StatusBadge;
